import { Shape } from '@/services/shape';
import {
  addResourceIfNotExists,
  generateLayoutAst,
  insertImages
} from '../utils/resource.utils';
import { buildAstState } from '..';
import { getRefName } from '../utils/name.utils';

/**
 * 返回类型为slot widget group的ast数据
 * @param resourceAst
 * @param shape
 * @returns
 */
export const getAppWidgetAst = (resourceAst: Ast, shape: Shape) => {
  const {
    x = 0,
    y = 0,
    appWidgetID,
    resources,
    recolorEnable,
    format
  } = shape.attrs;

  // 编辑器使用时，仅仅添加图片即可
  if (buildAstState.options.buildFor == 'editor') {
    const imageMap = insertImages(resourceAst, resources, {
      recolorEnable: !!recolorEnable,
      imgFormat: format
    });
    // 生成 layout ast
    const layoutAst: Ast = generateLayoutAst({
      ref: getRefName(imageMap['appWidgetPreview']),
      x,
      y
    });
    return layoutAst;
  } else {
    const ast: Ast = {
      tag: 'Slot',
      attrsMap: {
        type: 'appWidget',
        appWidgetID: appWidgetID ?? ''
      },
      children: []
    };
    const _ast = addResourceIfNotExists(resourceAst, ast);
    const layoutAst: Ast = generateLayoutAst({
      ref: '@' + _ast.attrsMap.name,
      x,
      y
    });

    return layoutAst;
  }
};
